import { Core } from "@faire/design-tokens";
import { pageMaxWidthCss } from "@faire/help-center/components/Mixin";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import React from "react";
import styled from "styled-components";

import { FaireIntro } from "./FaireIntro";
import { FaireLinks } from "./FaireLinks";
import { PolicyLinks } from "./PolicyLinks";

export const Footer: React.FC = () => {
  return (
    <>
      <FullWidthBorderedWrapper>
        <MainContentWrapper>
          <FaireIntro />
          <FaireLinks />
        </MainContentWrapper>
      </FullWidthBorderedWrapper>
      <FullWidthBorderedWrapper>
        <PolicyLinks />
      </FullWidthBorderedWrapper>
    </>
  );
};

const FullWidthBorderedWrapper = styled.div`
  ${responsiveMediaQueries.tabletAndAbove} {
    border-top: 1px solid ${Core.border.muted};
  }
`;

const MainContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${getSpacing("3x")};

  ${responsiveMediaQueries.tabletAndAbove} {
    flex-direction: row;
    padding: ${getSpacing("5x")};
  }

  ${responsiveMediaQueries.desktopAndAbove} {
    padding: ${getSpacing("5x", "7x")};
  }

  ${pageMaxWidthCss}
`;
